import { ThemeType } from "grommet";
import { base } from "grommet/themes/base";
import { deepMerge } from "grommet/utils";
import * as c from "./constants/colors";

const theme: ThemeType = deepMerge(base, {
  global: {
    colors: {
      brand: c.COLOR_PRIMARY,
      focus: c.COLOR_PRIMARY,
    },
    input: {
      weight: 400,
    },
    drop: {
      border: {
        radius: "4px",
      },
    },
  },
  anchor: {
    fontWeight: 400,
  },
});

export default theme;
